<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-row class="searchBar">
      <el-button
        size="small"
        v-hasPerm="btn_perm_type.dept.add"
        @click="handleEdit()"
        icon="el-icon-plus"
        >新增</el-button
      >
    </el-row>
    <!--列表-->
    <el-table
      row-key="id"
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column sortable prop="deptName" label="名称"> </el-table-column>
      <el-table-column sortable prop="orderNum" label="排序"> </el-table-column>
      <el-table-column
        sortable
        prop="createTime"
        label="创建时间"
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="状态"
        :formatter="handleFormatStatus"
      >
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.dept.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.dept.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :editForm="editForm"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
import { listDept, delDept } from "@/api/system/dept";
import EditForm from "./add-edit";
import { listToTree, timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      title: "添加部门",
      editForm: {
        deptName: "",
        orderNum: "",
        registerTIme: "",
        status: "",
      },
      userData: [],
    };
  },
  components: {
    EditForm,
  },
  created() {
    this.getData();
  },
  methods: {
    handleFormatStatus(row, column, cellValue) {
      if (cellValue === 0) {
        return "正常";
      }

      return "异常";
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    getData() {
      this.loading = true;
      listDept()
        .then((data) => {
          let tree = listToTree(data);
          this.userData = tree;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit(row) {
      if (row) {
        this.title = "修改部门";
        this.editForm = row;
      } else {
        this.title = "添加部门";
        this.editForm = {};
      }
      this.editFormVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delDept(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.toolBar {
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/system/department/index.vue